// extracted by mini-css-extract-plugin
var _1 = "tjs-feature-info-section__content";
var _2 = "tjs-feature-info-section__raw-data-button tjs-_buttons__btn tjs-_buttons__btn-primary tjs-_buttons__btn--small";
var _3 = "tjs-feature-info-section__raw-data-button tjs-_buttons__btn tjs-_buttons__btn-primary tjs-_buttons__btn--small";
var _4 = "tjs-feature-info-section__section tjs-_base__clearfix";
var _5 = "tjs-feature-info-section__time-series-chart";
var _6 = "tjs-feature-info-section__time-series-chart";
var _7 = "tjs-feature-info-section__title tjs-_buttons__btn";
export { _1 as "content", _2 as "raw-data-button", _3 as "rawDataButton", _4 as "section", _5 as "time-series-chart", _6 as "timeSeriesChart", _7 as "title" }
export default { "content": _1, "raw-data-button": _2, "rawDataButton": _3, "section": _4, "time-series-chart": _5, "timeSeriesChart": _6, "title": _7 }
